import React, { createContext, useContext, useEffect, useState } from 'react';

const WishlistContext = createContext(null);

export const WishlistProvider = ({ children }) => {
  const [slugs, setSlugs] = useState(() => {
    try {
      const raw = localStorage.getItem('vrr_wishlist');
      return raw ? JSON.parse(raw) : [];
    } catch (e) { return []; }
  });

  useEffect(() => {
    localStorage.setItem('vrr_wishlist', JSON.stringify(slugs));
  }, [slugs]);

  const has = (slug) => slugs.includes(slug);
  const toggle = (slug) => setSlugs(prev => prev.includes(slug) ? prev.filter(s => s !== slug) : [...prev, slug]);
  const remove = (slug) => setSlugs(prev => prev.filter(s => s !== slug));
  const clear = () => setSlugs([]);

  return (
    <WishlistContext.Provider value={{ slugs, has, toggle, remove, clear, count: slugs.length }}>
      {children}
    </WishlistContext.Provider>
  );
};

export const useWishlist = () => useContext(WishlistContext);
